<script setup lang="ts">
import ArticleContent from "@/components/article/ArticleContent.vue";
import ArticleContentCollapser from "@/components/article/ArticleContentCollapser.vue";
import type { CentlexArticle } from "@/types/article-formats/centlex";

import ArticleLemma from "./ArticleLemma.vue";
import ArticleMeanings from "./ArticleMeanings.vue";

const props = defineProps<{
  article: CentlexArticle;
  isCollapsible: boolean;
}>();
</script>

<template>
  <ArticleContent>
    <ArticleLemma :lemma="props.article.lemma" />
    <ArticleContentCollapser :is-collapsible="props.isCollapsible">
      <div class="article-content__body-container article-content__body-container--reading-lines">
        <ArticleMeanings
          :homonym-id="props.article.lemma.homonymId"
          :meanings="props.article.meanings"
        />
      </div>
    </ArticleContentCollapser>
  </ArticleContent>
</template>
